import { render, staticRenderFns } from "./gzdcjy.vue?vue&type=template&id=4fa4381e&scoped=true"
import script from "./gzdcjy.vue?vue&type=script&lang=js"
export * from "./gzdcjy.vue?vue&type=script&lang=js"
import style0 from "./gzdcjy.vue?vue&type=style&index=0&id=4fa4381e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4381e",
  null
  
)

export default component.exports